var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoaded)?_c('div',{staticClass:"easyvote-preloader"},[_c('span',{staticClass:"far fa-5x fa-spinner fa-spin"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }